"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _personnelManagement = require("@/api/authorityManagement/personnelManagement");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  data: function data() {
    return {
      loading: false,
      queryData: {
        uid: null,
        nickName: null,
        phone: null,
        roleId: null,
        page: {
          page: 1,
          size: 10
        }
      },
      tableData: [],
      total: 0,
      dialogVisible: false,
      ruleForm: {
        uid: null,
        nickname: '',
        phone: '',
        status: 0,
        adminRoleMappings: []
      },
      rules: {
        nickname: [{
          required: true,
          message: '请输入用户昵称',
          trigger: 'blur'
        }, {
          min: 0,
          max: 99,
          message: '长度在 0 到 99 个字符',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1[3-9]\d{9}$/,
          message: '请输入有效的手机号',
          trigger: ['blur', 'change']
        }],
        status: [{
          required: true,
          message: '请选择用户状态',
          trigger: 'change'
        }],
        adminRoleMappings: [{
          type: 'array',
          required: true,
          message: '请至少选择一个所属角色',
          trigger: 'change'
        }]
      },
      options: [],
      isDel: true,
      // 是否能删除
      ControlsType: true,
      // 添加
      showRole: null
    };
  },
  computed: {
    isShowRole: function isShowRole() {
      return !this.ControlsType && this.showRole === 0;
    }
  },
  created: function created() {
    this.queryUserPage();
    this.queryAdminRoles();
    // this.queryUserCanDelete()
  },
  methods: {
    queryUserCanDelete: function () {
      var _queryUserCanDelete2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {
                appId: 0
              };
              _context.n = 1;
              return (0, _personnelManagement.queryUserCanDelete)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.isDel = res.data;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function queryUserCanDelete() {
        return _queryUserCanDelete2.apply(this, arguments);
      }
      return queryUserCanDelete;
    }(),
    onInit: function onInit() {
      this.queryData = {
        uid: null,
        nickName: null,
        phone: null,
        roleId: null,
        page: {
          page: 1,
          size: 10
        }
      };
    },
    onInquire: function onInquire() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.queryUserPage();
    },
    onInitialize: function onInitialize() {
      this.onInit();
      this.queryUserPage();
    },
    // 列表查询
    queryUserPage: function () {
      var _queryUserPage2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              this.loading = true;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context2.n = 1;
              return (0, _personnelManagement.queryUserPage)(params);
            case 1:
              res = _context2.v;
              this.loading = false;
              if (res.code === 0) {
                this.tableData = res.data.data;
                this.total = res.data.total;
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              this.loading = false;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function queryUserPage() {
        return _queryUserPage2.apply(this, arguments);
      }
      return queryUserPage;
    }(),
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.queryUserPage();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.queryUserPage();
    },
    onEditor: function onEditor(row) {
      this.ControlsType = false;
      this.showRole = row.showRole;
      this.onInitRuleForm();
      this.queryUserInfo(row.uid);
      this.dialogVisible = true;
    },
    onDel: function onDel(row) {
      var _this = this;
      this.$confirm('是否确认删除该用户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.deleteUser(row.uid);
      });
    },
    // 添加用户
    onInitRuleForm: function onInitRuleForm() {
      this.ruleForm = {
        uid: null,
        nickname: '',
        phone: '',
        status: 0,
        adminRoleMappings: []
      };
    },
    onAdd: function onAdd() {
      this.showRole = null;
      this.ControlsType = true;
      this.onInitRuleForm();
      this.dialogVisible = true;
    },
    onClose: function onClose() {
      this.resetForm('ruleForm');
      this.dialogVisible = false;
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.$confirm('是否确认用户添加/编辑 操作?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this2.addOrUpdateAdminUser();
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 新增
    addOrUpdateAdminUser: function () {
      var _addOrUpdateAdminUser2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context3.n = 1;
              return (0, _personnelManagement.addOrUpdateAdminUser)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                console.log(res);
                this.dialogVisible = false;
                this.resetForm('ruleForm');
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.queryUserPage();
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function addOrUpdateAdminUser() {
        return _addOrUpdateAdminUser2.apply(this, arguments);
      }
      return addOrUpdateAdminUser;
    }(),
    // 所有角色
    queryAdminRoles: function () {
      var _queryAdminRoles2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var params, res, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = {};
              _context4.n = 1;
              return (0, _personnelManagement.queryAdminRoles)(params);
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.options = res.data;
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.log(_t4);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function queryAdminRoles() {
        return _queryAdminRoles2.apply(this, arguments);
      }
      return queryAdminRoles;
    }(),
    // 获取用户信息
    queryUserInfo: function () {
      var _queryUserInfo2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5(uid) {
        var params, res, data, _t5;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              params = {
                uid: uid,
                appId: 0
              };
              _context5.n = 1;
              return (0, _personnelManagement.queryUserInfo)(params);
            case 1:
              res = _context5.v;
              if (res.code === 0) {
                data = res.data;
                this.ruleForm.uid = data.uid;
                this.ruleForm.nickname = data.nickname;
                this.ruleForm.phone = data.phone;
                this.ruleForm.adminRoleMappings = data.relations.map(function (i) {
                  return i.roleId;
                });
                this.ruleForm.status = data.status;
              }
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t5 = _context5.v;
              console.log(_t5);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function queryUserInfo(_x) {
        return _queryUserInfo2.apply(this, arguments);
      }
      return queryUserInfo;
    }(),
    // 删除用户
    deleteUser: function () {
      var _deleteUser2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6(uid) {
        var params, res, _t6;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              params = {
                uid: uid
              };
              _context6.n = 1;
              return (0, _personnelManagement.deleteUser)(params);
            case 1:
              res = _context6.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '删除成功'
                });
                this.queryUserPage();
              }
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t6 = _context6.v;
              console.log(_t6);
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function deleteUser(_x2) {
        return _deleteUser2.apply(this, arguments);
      }
      return deleteUser;
    }()
  }
};